<template>
  <div>
    <base-header class="pb-6">
      <b-row class="align-items-center py-4">
        <b-col cols="12" class="d-flex align-items-center">
          <base-button
            v-if="viewMode == 'edit'"
            type="danger"
            class="mr-3"
            @click="cancel"
          >
            Back
          </base-button>
          <h6 class="h2 text-white d-inline-block mb-0">{{ $route.name }}</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb />
          </nav>
        </b-col>
      </b-row>
    </base-header>
    <div class="container-fluid mt--6">
      <b-card no-body class="mb-4">
        <!-- Card body -->
        <b-card-body>
          <b-card no-body>
            <!-- <b-card-header class="border-0">
              <b-row>
                <b-col cols="6"> </b-col>
                <b-col cols="6" class="text-right">
                  <el-tooltip content="Delete" placement="top">
                    <base-button type="danger" icon size="sm">
                      <span class="btn-inner--icon"
                        ><i class="fas fa-trash"></i
                      ></span>
                      <span class="btn-inner--text">Delete</span>
                    </base-button>
                  </el-tooltip>
                </b-col>
              </b-row>
            </b-card-header> -->

            <div class="editorContainer" v-if="viewMode == 'edit'">
              <div class="editorFrame">
                <!-- <div class="field-layout">
                  <div class="field-layout__col1">Content Template Id:</div>
                  <div class="field-layout__col2">
                    {{ currentItem.content_template_id }}
                  </div>
                </div>
                <div class="field-layout">
                  <div class="field-layout__col1">Content Template Name:</div>
                  <div class="field-layout__col2">
                    <input
                      v-model="currentItem.content_template_name"
                      type="text"
                    />
                  </div>
                </div> -->

                <b-card-body>
                  <b-row>
                    <b-col md="12">
                      <base-input
                        name="Content Template Id"
                        label="Content Template Id"
                        v-model="currentItem.email_template_id"
                        disabled
                      />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="12">
                      <base-input
                        name="Content Template Name"
                        label="Content Template Name"
                        v-model="currentItem.email_template_name"
                      />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="12">
                      <base-input
                        name="Email Subject Line"
                        label="Email Subject Line"
                        v-model="currentItem.email_template_subject_line"
                      />
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col md="12">
                      <base-input name="Tags" label="Tags">
                        <el-select
                          v-model="currentItem.tags"
                          multiple
                          filterable
                          allow-create
                          default-first-option
                          clearable
                          placeholder="Add tags (e.g. motor, plant, quote)"
                          class="w-100"
                        >
                          <el-option
                            v-for="tag in knownTags"
                            :key="tag"
                            :label="tag"
                            :value="tag"
                          />
                        </el-select>
                      </base-input>
                      <p class="text-muted small mb-0 mt-n2">
                        Type a new tag and press Enter. Used to filter the
                        template list — not used when sending email.
                      </p>
                    </b-col>
                  </b-row>
                </b-card-body>
                <div style="margin-left: 40px;margin-right: 40px;">
                  <EmailTemplateTipTapEditor
                    v-if="currentItem.email_template_id"
                    :key="currentItem.email_template_id"
                    v-model="html"
                  />

                  <div>
                    <h6 class="h4 d-inline-block mb-0">Attachments</h6>
                  </div>

                  <div>
                    <div
                      style="margin: 2px 0px 2px 0px"
                      v-for="attachment in currentAttachments"
                      :key="attachment.guid"
                    >
                      {{ attachment.filename }}
                      <button
                        class="remove-attachment"
                        @click="removeAttachment(attachment.guid)"
                      >
                        remove
                      </button>
                    </div>

                    <div class="mt-4">
                      <h6 class="h4 d-inline-block mb-0">Uploader</h6>
                    </div>

                    <div>
                      <uploader
                        :uploaderKey="'attachmentUploadFiles'"
                        @uploadComplete="uploadComplete"
                        :files="[]"
                        :resetFileListAfterUpload="true"
                      />
                    </div>
                  </div>
                  <div style="text-align:center;">
                    <base-button @click="saveItem()" type="primary" class="mb-4"
                      >Save Template</base-button
                    >

                    <base-button
                      @click="sendTestEmail()"
                      type="info"
                      class="mb-4 ml-2"
                      :disabled="sendingTestEmail"
                    >
                      {{
                        sendingTestEmail
                          ? "Sending…"
                          : "Send test email (to me)"
                      }}
                    </base-button>

                    <base-button
                      @click="cancel()"
                      type="secondary"
                      class="mb-4 btn-outline-primary"
                      >Cancel</base-button
                    >
                  </div>
                </div>

                <!-- <input @click="saveItem()" type="button" value="Save" /> &nbsp;
                <input @click="cancel()" type="button" value="Cancel" /> -->
              </div>
            </div>

            <div v-if="viewMode == 'list'">
              <b-row class="mb-3 px-3 align-items-center">
                <b-col md="4" sm="6">
                  <label class="form-control-label mb-1 d-block">
                    Filter by tag
                  </label>
                  <el-select
                    v-model="tagFilter"
                    clearable
                    filterable
                    placeholder="All tags"
                    class="w-100"
                  >
                    <el-option
                      v-for="tag in knownTags"
                      :key="tag"
                      :label="tag"
                      :value="tag"
                    />
                  </el-select>
                </b-col>
                <b-col
                  md="8"
                  sm="6"
                  class="d-flex flex-wrap align-items-center justify-content-md-end pt-3"
                >
                  <span class="text-muted small mr-3 mb-2 mb-md-0">
                    Showing {{ filteredEmailTemplates.length }} of
                    {{ emailTemplates.length }} template(s)
                  </span>
                  <base-button
                    v-if="canCopyToProduction && isSuperAdmin"
                    @click="compareAllWithProduction()"
                    type="info"
                    size="sm"
                    class="mb-0"
                    :disabled="comparingWithProduction"
                  >
                    {{
                      comparingWithProduction
                        ? "Comparing…"
                        : "Compare with Prod"
                    }}
                  </base-button>
                </b-col>
              </b-row>
              <p
                v-if="canCopyToProduction && isSuperAdmin"
                class="text-muted small px-3 mb-3"
              >
                Compare checks staging against production after the same URL rewrites
                and [STG] subject cleanup used when copying. Copy to production includes
                tags; attachments are not copied.
              </p>
              <el-table
                class="table-responsive table-flush"
                header-row-class-name="thead-light"
                row-key="email_template_id"
                :data="filteredEmailTemplates"
                @selection-change="onSelectionChange"
              >
                <el-table-column
                  type="selection"
                  align="left"
                  min-width="80px"
                >
                </el-table-column>

                <el-table-column
                  label="Template ID"
                  min-width="160px"
                  prop="email_template_id"
                  sortable
                  show-overflow-tooltip
                >
                  <template v-slot="{ row }">
                    <b>{{ row.email_template_id }}</b>
                  </template>
                </el-table-column>
                <el-table-column
                  label="Name"
                  min-width="140px"
                  prop="email_template_name"
                  sortable
                  show-overflow-tooltip
                />
                <el-table-column
                  label="Subject"
                  min-width="160px"
                  prop="email_template_subject_line"
                  sortable
                  show-overflow-tooltip
                >
                  <template v-slot="{ row }">
                    <span
                      class="text-muted"
                      :title="row.email_template_subject_line || ''"
                    >
                      {{ formatSubjectPreview(row.email_template_subject_line) }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="Tags" min-width="180px">
                  <template slot-scope="{ row }">
                    <div class="d-flex align-items-center flex-wrap">
                      <span
                        v-for="tag in row.tags || []"
                        :key="tag"
                        class="badge badge-primary mr-1 mb-1"
                      >
                        {{ tag }}
                      </span>
                      <span
                        v-if="!(row.tags && row.tags.length)"
                        class="text-muted mr-2 mb-1"
                        >—</span
                      >
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="canCopyToProduction && isSuperAdmin"
                  label="Prod"
                  width="90px"
                  align="center"
                >
                  <template slot-scope="{ row }">
                    <button
                      v-if="prodCompareStatus(row.email_template_id)"
                      type="button"
                      class="prod-compare-indicator"
                      :class="
                        prodCompareStatus(row.email_template_id).identical
                          ? 'is-match'
                          : 'is-diff'
                      "
                      :title="prodCompareTooltip(row.email_template_id)"
                      @click="showCompareDetails(row)"
                    >
                      <span aria-hidden="true">{{
                        prodCompareStatus(row.email_template_id).identical
                          ? "✓"
                          : "✗"
                      }}</span>
                    </button>
                    <span v-else class="text-muted">—</span>
                  </template>
                </el-table-column>
                <el-table-column
                  :width="canCopyToProduction && isSuperAdmin ? 220 : 144"
                  align="right"
                  label="Actions"
                >
                  <div
                    slot-scope="{ $index, row }"
                    class="d-flex justify-content-end align-items-center"
                  >
                    <base-button
                      v-if="canCopyToProduction && isSuperAdmin"
                      @click.native="copyToProduction(row)"
                      type="warning"
                      size="sm"
                      class="mr-2"
                      :disabled="copyingToProductionId === row.email_template_id"
                    >
                      {{
                        copyingToProductionId === row.email_template_id
                          ? "Copying…"
                          : "Copy to prod"
                      }}
                    </base-button>
                    <base-button
                      @click.native="handleEdit($index, row)"
                      class="edit"
                      type="success"
                      size="sm"
                      icon
                    >
                      <i class="text-white ni ni-ruler-pencil"></i>
                    </base-button>
                  </div>
                </el-table-column>
              </el-table>
            </div>
          </b-card>
        </b-card-body>
      </b-card>
    </div>

    <b-modal
      id="email-template-prod-compare-modal"
      v-model="compareModalOpen"
      size="xl"
      title="Compare with production"
      ok-only
      ok-title="Close"
      ok-variant="secondary"
      body-class="email-template-compare-modal-body"
    >
      <div v-if="compareResult">
        <p class="mb-2">
          <strong>{{ compareResult.email_template_id }}</strong>
          <span class="text-muted"> → {{ compareResult.prod_dbname }}</span>
        </p>

        <b-alert
          v-if="!compareResult.prodExists"
          show
          variant="warning"
          class="py-2"
        >
          This template does not exist on production yet.
        </b-alert>
        <b-alert
          v-else-if="compareResult.identical"
          show
          variant="success"
          class="py-2"
        >
          Identical to production after promote transforms.
        </b-alert>
        <b-alert v-else show variant="info" class="py-2">
          Differs from production in:
          {{ compareResult.differingFields.join(", ") }}
        </b-alert>

        <p
          v-if="compareResult.totalReplacements > 0"
          class="text-muted small"
        >
          Promote transforms applied for this comparison
          ({{ compareResult.totalReplacements }}):
          {{ formatRewriteSummary(compareResult.replacements) }}
        </p>
        <p v-else class="text-muted small">
          No URL/[STG] transforms needed for this staging content.
        </p>

        <div
          v-for="field in compareFieldDefs"
          :key="field.key"
          class="compare-field mb-3"
        >
          <div class="d-flex align-items-center mb-1">
            <strong>{{ field.label }}</strong>
            <span
              class="badge ml-2"
              :class="
                compareResult.fields[field.key].equal
                  ? 'badge-success'
                  : 'badge-warning'
              "
            >
              {{
                compareResult.fields[field.key].equal ? "Match" : "Different"
              }}
            </span>
          </div>

          <div
            v-if="field.key === 'tags'"
            class="compare-side-by-side"
          >
            <div>
              <div class="compare-col-label">Staging (as would land on prod)</div>
              <div class="compare-box">
                {{
                  (compareResult.fields.tags.stagingAsWouldBeOnProd || []).join(
                    ", "
                  ) || "—"
                }}
              </div>
            </div>
            <div>
              <div class="compare-col-label">Production</div>
              <div class="compare-box">
                {{
                  compareResult.fields.tags.production == null
                    ? "(missing)"
                    : (compareResult.fields.tags.production || []).join(", ") ||
                      "—"
                }}
              </div>
            </div>
          </div>

          <div
            v-else-if="field.key === 'email_template_html'"
            class="compare-side-by-side"
          >
            <div>
              <div class="compare-col-label">
                Staging (as would land on prod)
                <span class="text-muted">
                  — {{
                    (compareResult.fields.email_template_html
                      .stagingAsWouldBeOnProd || "").length
                  }}
                  chars
                </span>
              </div>
              <pre class="compare-box compare-html">{{
                compareResult.fields.email_template_html.stagingAsWouldBeOnProd
              }}</pre>
            </div>
            <div>
              <div class="compare-col-label">
                Production
                <span class="text-muted">
                  —
                  {{
                    compareResult.fields.email_template_html.production == null
                      ? "missing"
                      : (compareResult.fields.email_template_html.production || "")
                          .length + " chars"
                  }}
                </span>
              </div>
              <pre class="compare-box compare-html">{{
                compareResult.fields.email_template_html.production == null
                  ? "(missing on production)"
                  : compareResult.fields.email_template_html.production
              }}</pre>
            </div>
          </div>

          <div v-else class="compare-side-by-side">
            <div>
              <div class="compare-col-label">Staging (as would land on prod)</div>
              <div class="compare-box">
                {{
                  compareResult.fields[field.key].stagingAsWouldBeOnProd || "—"
                }}
              </div>
            </div>
            <div>
              <div class="compare-col-label">Production</div>
              <div class="compare-box">
                {{
                  compareResult.fields[field.key].production == null
                    ? "(missing)"
                    : compareResult.fields[field.key].production || "—"
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="text-muted">No comparison result.</div>
    </b-modal>
  </div>
</template>
<script>
import { GlobalStore } from "../../globalStore";
import { GlobalMethods } from "../../globalMethods";
import Uploader from "../components/fleetCommon/Uploader.vue";
import EmailTemplateTipTapEditor from "../../components/admin/EmailTemplateTipTapEditor.vue";
import users from "../users";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option
} from "element-ui";

import { appFunctions } from "../../helpers/appFunctions";
import { emailMethods } from "../../helpers/email";
import { toasts } from "../../helpers/toasts";

function normalizeTagsClient(tags) {
  if (!Array.isArray(tags)) {
    return [];
  }
  const seen = new Set();
  const result = [];
  tags.forEach(t => {
    const n = String(t || "")
      .trim()
      .toLowerCase();
    if (!n || seen.has(n)) {
      return;
    }
    seen.add(n);
    result.push(n);
  });
  return result;
}

export default {
  data() {
    return {
      users,
      realmApp: null,
      emailTemplates: [],
      currentItem: {},
      viewMode: "list",
      html: "",
      currentAttachments: [],
      sendingTestEmail: false,
      copyingToProductionId: "",
      comparingWithProduction: false,
      compareStatusesById: {},
      compareModalOpen: false,
      compareResult: null,
      compareFieldDefs: [
        { key: "email_template_name", label: "Name" },
        { key: "email_template_subject_line", label: "Subject" },
        { key: "tags", label: "Tags" },
        { key: "email_template_html", label: "HTML body" }
      ],
      tagFilter: ""
    };
  },
  name: "EmailTemplates",
  computed: {
    canCopyToProduction() {
      const site =
        process.env.VUE_APP_SITEURL ||
        (GlobalStore && GlobalStore.siteURL) ||
        "";
      return /partner-staging/i.test(String(site));
    },
    isSuperAdmin() {
      return !!(GlobalStore.brokerObj && GlobalStore.brokerObj.Broker_super_admin);
    },
    knownTags() {
      const set = new Set();
      (this.emailTemplates || []).forEach(tpl => {
        (tpl.tags || []).forEach(tag => {
          if (tag) {
            set.add(String(tag).toLowerCase());
          }
        });
      });
      return Array.from(set).sort((a, b) => a.localeCompare(b));
    },
    filteredEmailTemplates() {
      const filter = (this.tagFilter || "").trim().toLowerCase();
      if (!filter) {
        return this.emailTemplates;
      }
      return (this.emailTemplates || []).filter(tpl =>
        (tpl.tags || []).some(t => String(t).toLowerCase() === filter)
      );
    }
  },
  methods: {
    formatSubjectPreview(subject) {
      const text = String(subject || "").trim();
      if (!text) {
        return "—";
      }
      return text.length > 30 ? `${text.slice(0, 30)}…` : text;
    },
    removeAttachment(guid) {
      appFunctions
        .crud_emailTemplate("deleteAttachment", { guid })
        .then(resp => {
          this.getAttachments(this.currentItem.email_template_id);
        });
    },
    onEdit(row) {
      alert(`You want to edit ${row.name}`);
    },
    onDelete(row) {
      alert(`You want to delete ${row.name}`);
    },
    onSelectionChange(selectedRows) {
      this.selectedRows = selectedRows;
    },
    cancel() {
      this.viewMode = "list";
    },
    formatRewriteSummary(replacements) {
      if (!replacements || typeof replacements !== "object") {
        return "";
      }
      return Object.keys(replacements)
        .map(k => `${k}: ${replacements[k]}`)
        .join("; ");
    },
    prodCompareStatus(emailTemplateId) {
      return this.compareStatusesById[emailTemplateId] || null;
    },
    prodCompareTooltip(emailTemplateId) {
      const status = this.prodCompareStatus(emailTemplateId);
      if (!status) {
        return "Not compared yet";
      }
      if (status.identical) {
        return "Matches production (after promote transforms). Click for details.";
      }
      if (!status.prodExists) {
        return "Missing on production. Click for details.";
      }
      const fields = (status.differingFields || []).join(", ") || "content";
      return `Differs from production (${fields}). Click for details.`;
    },
    async compareAllWithProduction() {
      if (!this.isSuperAdmin) {
        toasts.error("Only super admins can compare templates with production.");
        return;
      }

      this.comparingWithProduction = true;
      try {
        const res = await appFunctions.crud_emailTemplate(
          "compareAllWithProd",
          {}
        );
        const result = res && res.data;
        const summaries = (result && result.summaries) || [];
        const next = {};
        summaries.forEach(summary => {
          if (summary && summary.email_template_id) {
            next[summary.email_template_id] = summary;
          }
        });
        this.compareStatusesById = next;

        const matches = summaries.filter(s => s && s.identical).length;
        const missing = summaries.filter(s => s && !s.prodExists).length;
        const differs = summaries.length - matches;
        toasts.success(
          `Compared ${summaries.length} template(s): ${matches} match, ${differs} differ${
            missing ? ` (${missing} missing on prod)` : ""
          }.`
        );
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.error) ||
          (e && e.message) ||
          "Could not compare templates with production.";
        toasts.error(msg);
      } finally {
        this.comparingWithProduction = false;
      }
    },
    async showCompareDetails(row) {
      const id = row && row.email_template_id;
      if (!id) {
        return;
      }
      try {
        const res = await appFunctions.crud_emailTemplate("compareWithProd", {
          email_template_id: id
        });
        const result = res && res.data;
        if (!result) {
          toasts.error(
            (res && res.error) || "Could not load comparison details."
          );
          return;
        }
        this.compareResult = result;
        this.compareModalOpen = true;
        this.$set(this.compareStatusesById, id, {
          email_template_id: id,
          prodExists: result.prodExists,
          identical: result.identical,
          differingFields: result.differingFields || [],
          totalReplacements: result.totalReplacements || 0
        });
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.error) ||
          (e && e.message) ||
          "Could not load comparison details.";
        toasts.error(msg);
      }
    },
    async copyToProduction(row) {
      const id = row && row.email_template_id;
      if (!id) {
        toasts.error("No template selected.");
        return;
      }
      if (!this.isSuperAdmin) {
        toasts.error("Only super admins can copy templates to production.");
        return;
      }

      const confirmed = window.confirm(
        [
          `Copy template "${id}" from staging to production?`,
          "",
          "This overwrites the production document with the same template id,",
          "including name, subject, HTML, and tags.",
          "",
          "URLs will be rewritten:",
          "  partner-staging → partner",
          "  partner-api-staging → partner-api",
          "",
          "[STG] will be removed from the subject line.",
          "Attachments are NOT copied."
        ].join("\n")
      );
      if (!confirmed) {
        return;
      }

      this.copyingToProductionId = id;
      try {
        const res = await appFunctions.crud_emailTemplate("promoteToProd", {
          email_template_id: id
        });
        const result = res && res.data;
        if (result && typeof result.totalReplacements === "number") {
          const parts = Object.keys(result.replacements || {})
            .map(k => `${k}: ${result.replacements[k]}`)
            .join("; ");
          toasts.success(
            `Copied "${id}" to production (${result.totalReplacements} URL rewrite(s)${
              parts ? `: ${parts}` : ""
            }).`
          );
        } else if (res && res.error) {
          toasts.error(res.error);
        } else {
          toasts.success(`Copied "${id}" to production.`);
        }

        this.$set(this.compareStatusesById, id, {
          email_template_id: id,
          prodExists: true,
          identical: true,
          differingFields: [],
          totalReplacements: (result && result.totalReplacements) || 0
        });
      } catch (e) {
        const msg =
          (e && e.response && e.response.data && e.response.data.error) ||
          (e && e.message) ||
          "Could not copy template to production.";
        toasts.error(msg);
      } finally {
        this.copyingToProductionId = "";
      }
    },
    async sendTestEmail() {
      if (!this.currentItem.email_template_id) {
        toasts.error("No template selected.");
        return;
      }
      this.sendingTestEmail = true;
      try {
        const r = await emailMethods.sendTestEmailForTemplate(
          GlobalStore.realmApp,
          {
            emailTemplateId: this.currentItem.email_template_id,
            subjectLine: this.currentItem.email_template_subject_line,
            templateHtml: this.html
          }
        );
        if (r.ok) {
          toasts.success(
            `Test email sent to ${GlobalStore.brokerObj.Broker_email}`
          );
        } else {
          toasts.error(r.error || "Could not send test email.");
        }
      } catch (e) {
        toasts.error(
          (e && e.message) || "Could not send test email."
        );
      } finally {
        this.sendingTestEmail = false;
      }
    },
    saveItem() {
      this.currentItem.email_template_html = this.html;
      this.currentItem.tags = normalizeTagsClient(this.currentItem.tags);
      appFunctions
        .crud_emailTemplate("update", this.currentItem)
        .then(resp => {
          console.log(resp);
          this.getEmailTemplates();
          this.viewMode = "list";
        });
    },
    async uploadComplete(filename) {
      const fileName = sessionStorage.getItem(filename);
      const fileContent = sessionStorage.getItem(
        filename.replace("_filename", "")
      );

      await appFunctions.addTemplateAttachment({
        templateName: this.currentItem.email_template_id,
        fileContent: fileContent,
        filename: fileName,
        guid: GlobalMethods.uuidv4()
      });

      this.getAttachments(this.currentItem.email_template_id);
    },
    getAttachments(id) {
      appFunctions.crud_emailTemplate("getAttachments", id).then(resp => {
        this.currentAttachments = resp.data;
      });
    },
    editItem(id) {
      this.viewMode = "edit";
      const found = this.emailTemplates.find(f => f.email_template_id === id);
      // Clone so list data is not mutated live; tags always an array
      this.currentItem = {
        ...(found || {}),
        tags: normalizeTagsClient(found && found.tags)
      };

      this.getAttachments(id);

      this.html = this.currentItem.email_template_html || "";
    },
    getEmailTemplates() {
      appFunctions.crud_emailTemplate("list").then(resp => {
        this.emailTemplates = (resp.data || []).map(tpl => ({
          ...tpl,
          tags: Array.isArray(tpl.tags) ? tpl.tags : []
        }));
      });
    },
    handleEdit(index, row) {
      this.editItem(row.email_template_id);
    }
  },
  async mounted() {
    this.realmApp = GlobalStore.realmApp;
    this.getEmailTemplates();
  },
  components: {
    EmailTemplateTipTapEditor,
    Uploader,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option
  }
};
</script>

<style lang="scss">
.w-100 {
  width: 100%;
}

.prod-compare-indicator {
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 18px;
  font-weight: 700;
  line-height: 1;
  padding: 2px 6px;
  border-radius: 4px;

  &.is-match {
    color: #2dce89;
  }

  &.is-diff {
    color: #f5365c;
  }

  &:hover {
    background: #f6f9fc;
  }
}

.email-template-compare-modal-body {
  max-height: 70vh;
  overflow-y: auto;
}

.compare-side-by-side {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.compare-col-label {
  font-size: 12px;
  color: #8898aa;
  margin-bottom: 4px;
}

.compare-box {
  background: #f7fafc;
  border: 1px solid #e9ecef;
  border-radius: 4px;
  padding: 8px 10px;
  font-size: 13px;
  word-break: break-word;
}

.compare-html {
  max-height: 280px;
  overflow: auto;
  white-space: pre-wrap;
  font-family: Menlo, Monaco, Consolas, "Courier New", monospace;
  font-size: 11px;
  margin: 0;
}

.remove-attachment {
  background: none !important;
  border: none;
  padding: 0 !important;
  /*optional*/
  font-family: arial, sans-serif;
  /*input has OS specific font-family*/
  color: #069;
  text-decoration: underline;
  cursor: pointer;
}

.emailTemplateList {
  table {
    margin: auto;
    width: 800px;
  }
  td {
    padding: 10px;
    text-align: left;
  }

  .editor__content {
    height: 400px;
    border: 1px solid lightgray;
    overflow-y: auto;
    text-align: left;
  }

  .editorFrame {
    width: 930px;
    margin: auto;
  }

  .field-layout {
    text-align: left;
    padding: 10px;
    position: relative;
    &__col1 {
      width: 200px;
      display: inline-block;
    }
    &__col2 {
      display: inline-block;
      input {
        width: 400px;
      }
    }
  }
}
</style>
